/* eslint-disable spellcheck/spell-checker */

import { queryEncode } from 'cio/helpers/query';

export const CONFIG = Object.freeze({
  campaign: {
    id: '1',
    name: 'In-app campaign',
    type: 'behavioral',
    anchors: queryEncode([{ negate: false, segments: [1], type: 'segments_negatable' }]),
    filters: '',
    workflow_action_ids: ['1', '2', '3', '4', '5', '6', '7'],
    edges: [
      {
        from: '1',
        to: '3',
        type: 'continue',
      },
      {
        from: '3',
        to: '4',
        type: 'continue',
      },
      {
        from: '4',
        to: '5',
        type: 'branch',
        index: 0,
      },
      {
        from: '4',
        to: '6',
        type: 'branch',
        index: 1,
      },
      {
        from: '4',
        to: '7',
        type: 'branch',
        index: 2,
      },
      {
        from: '4',
        to: '2',
        type: 'branch',
        index: 3,
      },
      {
        from: '5',
        to: '2',
        type: 'continue',
      },
      {
        from: '6',
        to: '2',
        type: 'continue',
      },
      {
        from: '7',
        to: '2',
        type: 'continue',
      },
    ],
  },
  actions: [
    {
      id: '1',
      type: 'filter_match_delay_action',
      campaign_id: '1',
    },
    {
      id: '2',
      type: 'exit_action',
      campaign_id: '1',
    },
    {
      id: '3',
      type: 'delay_seconds_action',
      delay: 259200,
      action_state: 'running',
      campaign_id: '1',
    },
    {
      id: '4',
      type: 'multi_split_branch_action',
      name: 'Test upgrades by messaging channel',
      multi_conditions: [
        queryEncode([{ field: 'channel', operator: 'eq', type: 'attribute', value: 'in-app' }]),
        queryEncode([{ field: 'channel', operator: 'eq', type: 'attribute', value: 'email' }]),
        queryEncode([{ field: 'channel', operator: 'eq', type: 'attribute', value: 'push' }]),
      ],
      campaign_id: '1',
    },
    {
      id: '5',
      type: 'in_app_action',
      name: 'Upgrade now',
      sending_state: 'automatic',
      campaign_id: '1',
      has_content: false,
      tracked: true,
      use_message_limits: null,
      send_to_unsubscribed: null,
    },
    {
      id: '6',
      type: 'email_action',
      name: 'Upgrade now',
      sending_state: 'automatic',
      campaign_id: '1',
      has_content: false,
      tracked: true,
      use_message_limits: null,
      send_to_unsubscribed: null,
    },
    {
      id: '7',
      type: 'push_action',
      name: 'Upgrade now',
      sending_state: 'automatic',
      campaign_id: '1',
      has_content: false,
      tracked: true,
      use_message_limits: null,
      send_to_unsubscribed: null,
    },
  ],
});
